import { CountUp, CountUpOptions } from "countup.js";

export class CountUpElement extends HTMLElement {
    private counter: CountUp | undefined;

    private static observer = createObserver();

    connectedCallback() {
        const $element = this;

        const endVal = parseFloat($element.textContent?.trim() || '0');

        const options: CountUpOptions = {
            useEasing: true,
            easingFn: easingFn,
            useGrouping: true,
            separator: ' ',
            decimal: ',',
            prefix: this.getAttribute('prefix') || '',
            suffix: this.getAttribute('suffix') || '',
            startVal: 0,
            decimalPlaces: countDecimals(endVal),
            duration: parseFloat(this.getAttribute('duration')!) || 2.5,
        };

        this.counter = new CountUp($element, endVal, options);

        CountUpElement.observer.observe(this);
    }

    disconnectedCallback() {
        CountUpElement.observer.unobserve(this);
    }

    start() {
        if (this.counter) {
            this.counter.reset();
            this.counter.start();
        }
    }
}

function countDecimals(num: number) {
    var decimals = num.toString().split('.')[1];
    return (decimals || '').length;
}

function easingFn(t: number, b: number, c: number, d: number) {
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (tc + -3 * ts + 3 * t);
}

function createObserver() {
    const options = {
        root: null,
        rootMargin: "0px",
    };

    const handleIntersect = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                (entry.target as CountUpElement).start();
            }
        });
    }

    return new IntersectionObserver(handleIntersect, options);
}

customElements.define('count-up', CountUpElement);